import { IconButton, InputAdornment } from "@mui/material";
import { TextField } from "./TextField";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import React, { useEffect } from "react";
import { SxProps } from "@mui/material/styles";
import { Theme } from "@mui/material/styles/createTheme";
import {
  FieldPath,
  FieldValues,
  RegisterOptions,
  useFormContext,
} from "react-hook-form";

interface IProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> {
  fieldName: string;
  fieldLabel?: string;
  sx?: SxProps<Theme>;
  required?: boolean;
  rules?: Omit<
    RegisterOptions<TFieldValues, TName>,
    "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"
  >;
  isDisabled?: boolean;
  defaultValue?: string;
}

export const EmailInputField = (props: IProps) => {
  const { fieldName, fieldLabel, sx, required, rules } = props;
  const { setValue } = useFormContext();

  useEffect(() => {
    if (props.defaultValue) {
      setValue(fieldName, props.defaultValue);
    }
  }, [props.defaultValue]);

  return (
    <TextField
      fieldName={fieldName}
      type="email"
      fieldLabel={fieldLabel}
      autoComplete="email"
      autoFocus={false}
      rules={{
        required: "Field Cannot Be Empty",
        pattern: {
          value: /^(?! )[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}(?<! )$/,
          message: "Invalid email",
        },
        minLength: {
          value: 3,
          message: "Email must be at least 3 characters long",
        },
        validate: (value) => {
          if (/\s/.test(value)) {
            return "Invalid email";
          }
          const atIndex = value.indexOf("@");
          const substringBeforeAt = value.slice(0, atIndex);
          const dotCount = (substringBeforeAt.match(/\./g) || []).length;
          if (dotCount >= 3) {
            return "Invalid email";
          }
          return true;
        },
        ...rules,
      }}
      inputProps={{ maxLength: 254 }}
      sx={{ mb: "20px", ...sx }}
      required={required}
      disabled={props.isDisabled}
    />
  );
};
